import { NoOrganisationsConnected } from '../NoOrganisationsConnected';
import { useGetSelectedOrganisation } from '../../hooks/useGetSelectedOrganisation';

import { WidgetsRoot } from './Widgets/WidgetsRoot';

export function Dashboard() {
  const currentOrg = useGetSelectedOrganisation();

  if (!currentOrg) {
    return <NoOrganisationsConnected />;
  }

  return <WidgetsRoot />;
}
